module.exports = __webpack_public_path__ + "static/media/craft.83adcb0f.jpg";